var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_3975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.781333 12.7459C0.281202 13.2459 0.000151033 13.9241 0 14.6312L0 15.9999H1.36867C2.07585 15.9997 2.75402 15.7187 3.254 15.2186L12.1493 6.32325L9.67667 3.85059L0.781333 12.7459Z",
    fill: "#A3A9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4298 0.570239C15.2675 0.407729 15.0747 0.278809 14.8625 0.19085C14.6503 0.102891 14.4228 0.0576172 14.1931 0.0576172C13.9634 0.0576172 13.736 0.102891 13.5238 0.19085C13.3116 0.278809 13.1188 0.407729 12.9565 0.570239L10.6191 2.90824L13.0918 5.38091L15.4298 3.04357C15.5923 2.88123 15.7212 2.68845 15.8092 2.47626C15.8972 2.26406 15.9424 2.03661 15.9424 1.80691C15.9424 1.5772 15.8972 1.34975 15.8092 1.13755C15.7212 0.925358 15.5923 0.73258 15.4298 0.570239Z",
    fill: "#A3A9B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_3975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.48697bd613443747ea744183aab43d19.svg";
export { ForwardRef as ReactComponent };